// 相册后台（/admin）的接口地址。
//
// ⚠️ 这里只能放「公开的地址」，绝不能出现任何密钥 / Token ——
//    本站是纯静态站，本文件会被原样部署到 CDN，等于贴在公网上。
//    真正的凭据（GitHub Token、密码哈希）全部在 ECS 上的 /opt/xhj-pics/config.json。
export const ADMIN_API_BASE = 'https://api.xhja.cn/pics'

// 图片的对外前缀。刻意写死成绝对地址：后台要「复制链接」给博客用，
// 在本地预览（127.0.0.1）里也必须复制出线上地址，不能跟着当前域名走。
export const PUBLIC_PHOTO_BASE = 'https://pics.xhja.cn/photos'

// 票据存在 sessionStorage：关掉标签页就没了，也不会被别的标签页共用
export const TICKET_STORAGE_KEY = 'xhj-pics-ticket'
